import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import queryBannerImage from "../../hooks/query-banner-image"
import useMinimalConfig from "../../hooks/use-minimal-config"
import useSiteMetadata from "../../hooks/use-site-metadata"
import replaceSlashes from "../../../utils/replace-slashes"
import { withCurrentCopyrightYear } from "../../../utils/copyright-year"
import { createMarkup } from "../../../utils/markup-creator"
import { splitCopyrightText } from "../../../utils/footer-copyright"
import { FooterType } from "../../types"
import { isDesktopScreen } from "../../../utils/measure-screen-size"

type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const FooterMediaLanding = ({ footer, ...props }: LayoutProps) => {
  const { footerNavigation: nav, basePath } = useMinimalConfig()
  const { siteImage, siteTitle, footerCopyrightText, footerPhoneNumber } = useSiteMetadata()
  const { copyright, disclaimer } = splitCopyrightText(footerCopyrightText ? footerCopyrightText.toString() : ``)
  const logoImage = queryBannerImage(footer?.logo || siteImage)
  const [height, setHeight] = useState(18)
  const logoImageAspectRatio = logoImage
    ? logoImage?.node?.gatsbyImageData.width / logoImage?.node?.gatsbyImageData.height
    : 1

  useEffect(() => {
    setHeight(isDesktopScreen() ? 36 : 18)
  })

  return (
    <footer
      className={`${
        footer.advanced?.class || `bg-footerBackground text-footerColor`
      } py-6 md:py-12 px-6 sm:px-6 lg:px-0`}
    >
      <div className="max-w-screen-lg mx-auto md:flex md:items-center md:justify-between ">
        <div className="lg:order-1">
          <img
            src={footer?.logo}
            className="mx-auto"
            style={{ height: `100%`, width: `100%`, maxWidth: "350px" }}
            alt={siteTitle}
          />
        </div>

        <div className="mt-4 lg:mt-0 flex justify-center gap-2 lg:gap-0 lg:justify-center lg:space-x-6 lg:order-2">
          {nav &&
            nav.map((item: any, itemIndex: any) => (
              <Link
                key={item.slug}
                className="flex-1 text-center lg:text-left lg:flex-none text-footerColor text-xs lg:text-base 2xl:text-xl font-base md:font-bold font-roboto"
                to={replaceSlashes(`/${basePath}/${item.slug}`)}
              >
                {item.title}
              </Link>
            ))}
        </div>
      </div>

      {footerCopyrightText && (
        <div className="max-w-screen-lg mx-auto pb-6 pt-10 text-center md:text-left text-footerColor text-sm 2xl:text-xl">
          <div dangerouslySetInnerHTML={createMarkup(withCurrentCopyrightYear(copyright))}></div>
          {footerPhoneNumber && <p className="mt-4">{footerPhoneNumber}</p>}
          {disclaimer && <div className="mt-4" dangerouslySetInnerHTML={createMarkup(disclaimer)}></div>}
        </div>
      )}
    </footer>
  )
}

export default FooterMediaLanding
